import { useEffect } from 'react';
import SharedHeader from '../../components/feature/SharedHeader';
import Footer from '../home/components/Footer';

export default function TermsOfUse() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SharedHeader />
      
      <main className="max-w-[900px] mx-auto px-6 lg:px-8 py-20">
        <h1 className="text-[42px] font-bold text-[#111111] mb-4">
          Terms of Use
        </h1>
        
        <p className="text-[15px] text-[#666666] mb-12">
          By accessing this website, you agree to the following terms.
        </p>

        <div className="space-y-10">
          {/* Section 1 */}
          <section>
            <h2 className="text-[24px] font-semibold text-[#111111] mb-4">
              1. Informational Purpose Only
            </h2>
            <p className="text-[15px] text-[#666666] leading-relaxed">
              All content is provided for general informational purposes only and does not constitute financial, legal, tax or investment advice.
            </p>
          </section>

          {/* Section 2 */}
          <section>
            <h2 className="text-[24px] font-semibold text-[#111111] mb-4">
              2. No Regulated Services
            </h2>
            <p className="text-[15px] text-[#666666] leading-relaxed">
              Precious Leader Trade Far East Limited does not provide regulated financial services. All advisory services are strategic and non-regulated.
            </p>
          </section>

          {/* Section 3 */}
          <section>
            <h2 className="text-[24px] font-semibold text-[#111111] mb-4">
              3. No Offer
            </h2>
            <p className="text-[15px] text-[#666666] leading-relaxed">
              Nothing on this website constitutes an offer to buy or sell financial instruments or securities.
            </p>
          </section>

          {/* Section 4 */}
          <section>
            <h2 className="text-[24px] font-semibold text-[#111111] mb-4">
              4. Limitation of Liability
            </h2>
            <p className="text-[15px] text-[#666666] leading-relaxed">
              We are not liable for any direct or indirect losses arising from reliance on website information.
            </p>
          </section>

          {/* Section 5 */}
          <section>
            <h2 className="text-[24px] font-semibold text-[#111111] mb-4">
              5. Intellectual Property
            </h2>
            <p className="text-[15px] text-[#666666] leading-relaxed">
              All content, text, branding and design elements are property of the Company unless otherwise stated.
            </p>
          </section>

          {/* Section 6 */}
          <section>
            <h2 className="text-[24px] font-semibold text-[#111111] mb-4">
              6. Governing Law
            </h2>
            <p className="text-[15px] text-[#666666] leading-relaxed">
              These terms are governed by the laws of Hong Kong.
            </p>
          </section>
        </div>

        {/* Contact Section */}
        <div className="mt-16 pt-10 border-t border-gray-200">
          <p className="text-[15px] text-[#666666] leading-relaxed">
            For questions regarding these Terms of Use, please contact us at:{" "}
            <a 
              href="mailto:info@precious-leader-trade.com" 
              className="text-[#B11226] hover:underline"
            >
              info@precious-leader-trade.com
            </a>
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
}